import React, {Component} from 'react';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import Avatar from "@material-ui/core/Avatar";
import ImageIcon from '@material-ui/icons/Image';
import {format} from 'date-fns';
import Paper from "@material-ui/core/Paper";
import Divider from "@material-ui/core/Divider";
import TextField from "@material-ui/core/TextField";
import SearchIcon from '@material-ui/icons/Search';
import InputBase from "@material-ui/core/InputBase";
import AddCircleOutlineIcon from "@material-ui/icons/AddCircleOutline";
import Button from "@material-ui/core/Button";
import {Dialog, DialogActions, DialogContentText, DialogTitle, FormLabel, Radio, RadioGroup} from "@material-ui/core";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormControl from "@material-ui/core/FormControl";

class ProjectList extends Component {

    state = {
        searchValue: "",
        open: false,
        projectType: "AREA_COVERAGE"
    }

    onChangeSearchValue = (evt) => {
        console.log(evt.target.value)
        this.setState({
            searchValue: evt.target.value
        })
    }

    handleClickOpen = () => {
        this.setState({
            open: true
        })
    };

    handleClickClose = () => {
        this.setState({
            open: false
        })
    };


    handleCreateProject = () => {
        this.setState({
            open: false
        })

        this.props.handleNewPoject(this.state.projectType);
        this.setState({
            projectType: "AREA_COVERAGE"
        })
    };

    handleProjectTypeChange = (event) => {
        this.setState({
            projectType: event.target.value
        });
    };



    render() {

        const {projects} = this.props;

        return (
            <div>
            <Paper>
                <Button style={{margin: '5px'}} variant="outlined" onClick={this.handleClickOpen}>
                    <AddCircleOutlineIcon/>
                    New
                </Button>
                <Dialog open = {this.state.open} onClose={this.handleClose}>
                    <div style={{padding: '50px'}}>
                        <DialogTitle id="form-dialog-title">Create new Project</DialogTitle>
                        <DialogContentText>
                            Please select the type
                        </DialogContentText>
                        <FormControl component="fieldset">
                            <FormLabel component="legend"></FormLabel>
                            <RadioGroup aria-label="projectType" name="projectType1" value={this.state.projectType} onChange={this.handleProjectTypeChange}>
                                <FormControlLabel value="AREA_COVERAGE" control={<Radio />} label="Area Coverage" />
                                <FormControlLabel value="SCATTERED_REGIONS_VISITATION" control={<Radio />} label="Scattered Regions Visitation" />
                            </RadioGroup>
                        </FormControl>
                        <DialogActions>
                            <Button onClick={this.handleClickClose} color="primary">
                                Cancel
                            </Button>
                            <Button onClick={this.handleCreateProject} color="primary">
                                Create
                            </Button>
                        </DialogActions>
                    </div>

                </Dialog>
                <div style={{display: "flex",  'align-items': 'center',
                    'justify-content': 'center', }}>
                    <SearchIcon/>
                    <InputBase style={{'border': '1px solid #ccc', 'border-radius': '16px'}}
                        placeholder="Search…"
                        onChange={this.onChangeSearchValue}
                        type="search"
                    />
                </div>


            </Paper>
                <Paper>
                    {projects.filter(project => project.name.toLowerCase().includes(this.state.searchValue.toLowerCase())).map(project => (
                        <List>
                            <ListItem
                                onClick={() => {
                                    this.props.onClickProject(project)
                                }}
                                button>
                                <ListItemAvatar>
                                    <Avatar>
                                        <ImageIcon/>
                                    </Avatar>
                                </ListItemAvatar>
                                <ListItemText primary={project.name}
                                              secondary={"Updated: " + format((new Date(project.updated)), 'dd/MM/yyyy h:mm a')}/>
                            </ListItem>
                            <Divider/>
                        </List>))
                    }
                    <div>Contact: pkapoutsis@iti.gr</div>
                </Paper>
            </div>)
    }
}

export default ProjectList;
